import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"
import DownloadLink from "../../common/downloadLink/DownloadLink"
import DownloadIcon from "../../../assets/svgs/download-icon-dark.svg"
import { DownloadButton } from "./DownloadButton"

const PositionContainer = styled.div`
  position: relative;
  box-shadow: rgb(122, 121, 121, 0.2) 0px 0px 0px 1px,
    0px 4px 10px rgba(0, 0, 0, 0.15);
  background: #ffffff;
  width: 264px;

  padding-top: 36px;

  @media (min-width: 40em) {
    width: min(100%, 450px);
  }

  @media (min-width: 64em) {
    margin-top: 6rem;
    width: 264px;
    margin-right: auto;
  }
`

const PositionLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 2rem 2rem;
  gap: 0.5rem;
  isolation: isolate;

  @media (min-width: 40em) {
    flex-direction: row;
  }

  @media (min-width: 64em) {
    flex-direction: column;
  }
`

const Statistics = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
`

const Title = styled.h2`
  font-size: 1.5em;
  font-weight: 700;
  font-family: var(--ff-secondary);
  color: var(--clr-text-blue);
  line-height: 32px;
  margin-bottom: 0.5rem;
`

const Text = styled.p`
  color: var(--clr-text-blue);
  font-family: Poppins;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 1.3125rem */
`

const NoWrap = styled.span`
  //white-space: nowrap;
`

const Insights = () => {
  return (
    <PositionContainer>
      <PositionLayout>
        <Statistics>
          <Title>
            Rebase Digest <NoWrap>January - April 2025</NoWrap>
          </Title>
          <StaticImage
            src="../../../assets/images/generic_booklet.png"
            alt="Finding the right IT consultant"
            style={{ aspectRatio: "1.05", maxWidth: "190px" }}
          />
          <Text>
            Would you like to know more about role-specific salaries, billable
            rates, project opportunities and employee satisfaction?
          </Text>
          <DownloadLink formId="5d536023-dd24-4e5a-a054-1927ede743d1">
            <div
              style={{
                display: "flex",
                cursor: "pointer",
                alignItems: "center",
              }}
            >
              <DownloadIcon style={{ height: "16px" }} />
              <DownloadButton>Download Rebase Digest</DownloadButton>
            </div>
          </DownloadLink>
        </Statistics>
      </PositionLayout>
    </PositionContainer>
  )
}

export default Insights
